import { loginStart, loginSuccess, loginFailure, logout } from "./reducer";
import { AppDispatch } from "../../types";
import api from "../../../helpers/api_helper";

interface LoginCredentials {
  mobile_number: string;
  password: string;
  grant_type: string;
  app_id: string;
}

export const loginUser = (credentials: LoginCredentials) => async (dispatch: AppDispatch) => {
  try {
    dispatch(loginStart());
    
    const { app_id, ...rest } = credentials as any;

    // First attempt without app_id
    let response;
    try {
      response = await api.post('/users/login/', rest);
    } catch (err: any) {
      const errMsg = err?.response?.data?.non_field_errors?.[0] || '';
      const needsAppId = typeof errMsg === 'string' && errMsg.toLowerCase().includes('privileges required for login without app_id');
      if (!needsAppId || !app_id) throw err;
      // Retry with app_id for regular users
      response = await api.post('/users/login/', { ...rest, app_id });
    }

    console.log('Login success:', response.data);
    console.log('Login success:', response.data);
    
    dispatch(loginSuccess(response.data));
    return response.data;
    
  } catch (error: any) {
    console.error('Login error:', error);
    dispatch(loginFailure('Login failed - please try again'));
    throw error;
  }
};

// Simple logout function
export const logoutUser = () => async (dispatch: AppDispatch) => {
  try {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    dispatch(logout());
  } catch (error) {
    console.error('Logout error:', error);
  }
};

// Simple social login placeholder
export const socialLogin = (type: any, history: any) => async (dispatch: AppDispatch) => {
  try {
    console.log('Social login not implemented for type:', type);
    // For now, just redirect to dashboard
    history('/dashboard');
  } catch (error) {
    console.error('Social login error:', error);
  }
};